"use strict";

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Color = exports.H3Alternate = exports.CapitalSmall = exports.BodySmallTransparent = exports.BodyCapital = exports.CapitalBold = exports.Capital = exports.BodySmaller = exports.BodySmall = exports.Body = exports.BodyLarger = exports.BodyLarge = exports.H2Subtitle = exports.H1Subtitle = exports.H4 = exports.H3 = exports.H2 = exports.H1 = exports.generateStyle = exports.FontWeight = void 0;

var antd_1 = require("antd");

var lodash_1 = require("lodash");

var react_1 = __importStar(require("react"));

var styledTypes_1 = require("./styledTypes");

require("antd/lib/typography/style");

var FontWeight;

(function (FontWeight) {
  FontWeight[FontWeight["Light"] = 300] = "Light";
  FontWeight[FontWeight["Normal"] = 400] = "Normal";
  FontWeight[FontWeight["SemiBold"] = 500] = "SemiBold";
  FontWeight[FontWeight["Bold"] = 600] = "Bold";
  FontWeight[FontWeight["ExtraBold"] = 800] = "ExtraBold";
})(FontWeight = exports.FontWeight || (exports.FontWeight = {}));

var generateStyle = function generateStyle(theme, props) {
  return Object.assign({
    color: props.color ? theme[props.color] : undefined,
    fontSize: props.size ? theme[props.size] : undefined,
    fontWeight: props.weight,
    fontFamily: props.code ? theme['@code-family'] : undefined,
    marginBottom: props.isBlock ? undefined : 0
  }, props.style);
};

exports.generateStyle = generateStyle;
var PROPS_BLACKLIST = ['code', 'color', 'size', 'style', 'weight', 'isBlock', 'useDiv'];

var Header = function Header(_a) {
  var level = _a.level,
      props = __rest(_a, ["level"]);

  var theme = (0, react_1.useContext)(styledTypes_1.ThemeContext);
  return react_1["default"].createElement(antd_1.Typography.Title, Object.assign({
    level: level,
    style: (0, exports.generateStyle)(theme, Object.assign({
      isBlock: true
    }, props))
  }, (0, lodash_1.omit)(props, PROPS_BLACKLIST)));
};

var Item = function Item(props) {
  var theme = (0, react_1.useContext)(styledTypes_1.ThemeContext);

  if (!props.useDiv && props.dangerouslySetInnerHTML) {
    console.warn('You should not be rendering a <p> element while also using dangerouslySetInnerHTML. ' + 'Use the useDiv property on your typography element instead.');
  }

  if (props.useDiv) {
    return react_1["default"].createElement("div", Object.assign({
      style: (0, exports.generateStyle)(theme, props)
    }, (0, lodash_1.omit)(props, PROPS_BLACKLIST)));
  } else {
    return react_1["default"].createElement("p", Object.assign({
      style: (0, exports.generateStyle)(theme, props)
    }, (0, lodash_1.omit)(props, PROPS_BLACKLIST)));
  }
};

var H1 = function H1(props) {
  return react_1["default"].createElement(Header, Object.assign({
    level: 1
  }, props));
};

exports.H1 = H1;

var H2 = function H2(props) {
  return react_1["default"].createElement(Header, Object.assign({
    level: 2
  }, props));
};

exports.H2 = H2;

var H3 = function H3(props) {
  return react_1["default"].createElement(Header, Object.assign({
    level: 3
  }, props));
};

exports.H3 = H3;

var H4 = function H4(props) {
  return react_1["default"].createElement(Header, Object.assign({
    level: 4
  }, props));
};

exports.H4 = H4;

var H1Subtitle = function H1Subtitle(props) {
  return react_1["default"].createElement(Item, Object.assign({
    color: '@text-color-secondary',
    size: '@size-m'
  }, props));
};

exports.H1Subtitle = H1Subtitle;

var H2Subtitle = function H2Subtitle(props) {
  return react_1["default"].createElement(Item, Object.assign({
    color: '@text-color-secondary',
    size: '@size-s'
  }, props));
};

exports.H2Subtitle = H2Subtitle;

var BodyLarge = function BodyLarge(props) {
  return react_1["default"].createElement(Item, Object.assign({
    size: '@font-size-lg'
  }, props));
};

exports.BodyLarge = BodyLarge;

var BodyLarger = function BodyLarger(props) {
  return react_1["default"].createElement(Item, Object.assign({
    size: '@font-size-larger'
  }, props));
};

exports.BodyLarger = BodyLarger;

var Body = function Body(props) {
  return react_1["default"].createElement(Item, Object.assign({
    size: '@font-size-base'
  }, props));
};

exports.Body = Body;

var BodySmall = function BodySmall(props) {
  return react_1["default"].createElement(Item, Object.assign({
    size: '@font-size-sm'
  }, props));
};

exports.BodySmall = BodySmall;

var BodySmaller = function BodySmaller(props) {
  return react_1["default"].createElement(Item, Object.assign({
    size: '@font-size-xs'
  }, props));
};

exports.BodySmaller = BodySmaller;

var Capital = function Capital(props) {
  return react_1["default"].createElement(exports.Body, Object.assign({
    size: '@font-size-sm',
    color: '@text-color-secondary'
  }, props, {
    style: Object.assign(Object.assign({}, props.style), {
      fontWeight: 800,
      textTransform: 'uppercase',
      letterSpacing: '1px',
      lineHeight: 1
    })
  }));
};

exports.Capital = Capital;

var CapitalBold = function CapitalBold(props) {
  return react_1["default"].createElement(exports.Capital, Object.assign({
    color: '@text-color'
  }, props));
};

exports.CapitalBold = CapitalBold;

var BodyCapital = function BodyCapital(props) {
  return react_1["default"].createElement(exports.Capital, Object.assign({
    size: '@font-size-base'
  }, props));
};

exports.BodyCapital = BodyCapital;

var BodySmallTransparent = function BodySmallTransparent(props) {
  return react_1["default"].createElement(exports.BodySmall, Object.assign({
    color: '@white'
  }, props, {
    style: Object.assign(Object.assign({}, props.style), {
      opacity: 0.45
    })
  }));
};

exports.BodySmallTransparent = BodySmallTransparent;

var CapitalSmall = function CapitalSmall(props) {
  return react_1["default"].createElement(exports.Capital, Object.assign({
    size: '@font-size-xs'
  }, props, {
    style: Object.assign(Object.assign({}, props.style), {
      letterSpacing: '0.75px'
    })
  }));
};

exports.CapitalSmall = CapitalSmall;

var H3Alternate = function H3Alternate(props) {
  return react_1["default"].createElement(exports.H3, Object.assign({}, props, {
    style: Object.assign(Object.assign({}, props.style), {
      textTransform: 'none',
      fontSize: 22,
      lineHeight: '26px',
      letterSpacing: '-0.5px'
    })
  }));
};

exports.H3Alternate = H3Alternate;
exports.Color = styledTypes_1.styled.span(_templateObject(), function (props) {
  return props.theme[props.color];
});